import React, { useEffect, useState } from "react";
import {
  SlSelect,
  SlOption,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import {
  languageOptions,
  stateOptions,
  roles,
  BACKFILL_GAM_INTERNAL_OPTIONS,
  getBackfillGamPageOptions,
  getBackfillGamPageLabel,
  normalizeBackfillGamPage,
  isOnly300x250,
} from "../../utils/constants";
import { useNavigate } from "react-router";
import InternalAds from "./InternalAds";
import BackfillGAMForm from "./BackfillGamForm";
import { scrollToSection, getPositionClassName, buildDonutFromCounts, DIMENSION_LEGEND } from "./AdUnit";

function BackfillAdUnits() {
  const navigate = useNavigate();
  const [adData, setAdData] = useState({});
  const [loader, setLoader] = useState(false);
  const [langfilter, setLangFilter] = useState("1");
  const [statefilter, setStatefilter] = useState(-1);
  const [districtselect, setSelectdistrict] = useState(-1);
  const [districtfilter, setDistrictfilter] = useState([]);
  const [selectedConstituency, setSelectedConstituency] = useState(-1);
  const [constituencyfilter, setConstituencyfilter] = useState([]);
  const [showInternalAds, setShowInternalAds] = useState(false);
  const [internalAds, setInternalAds] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState();
  const [addFrom, setAddFrom] = useState();
  const [rotation, setRotation] = useState(0);
  const [selectedSlot, setSelectedSlot] = useState(3);
  const [selectedGamBackfillType, setSelectedGamBackfillType] = useState({});
  const [editingGamBackfillType, setEditingGamBackfillType] = useState({});
  const [target_filter, setTarget_filter] = useState({
    lang_id: "1",
    state_id: -1,
    district_id: -1,
    constituency_id: -1,
    zone_id: -1,
  });
  const [disableActions] = useState(localStorage.getItem('role') === roles.vendor_admin)
  const [scheduled, setScheduled] = useState(false)
  const handleScheduled = () =>{
      setScheduled(prev => !prev)
  }
  const fetchAds = async (
    _page = 0,
    targetFilter = {
      lang_id: "1",
      state_id: -1,
      district_id: -1,
      constituency_id: -1,
      zone_id: -1,
    },
  ) => {
    setLoader(true);
    try {
      const res = await api({
        url: "/backfilladunit/getBackfillAdUnits",
        method: "POST",
        responseType: "json",
        data: { target_filter: targetFilter, scheduled },
      });
      if (res.code === 200) {
        if (res.data) setAdData(res.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchAds(0, target_filter);
  }, [scheduled]);

  const LanguageFilterChange = (e) => {
    const value = e.target.value;
    setLangFilter(value);
    setStatefilter(-1);
    setSelectdistrict(-1);
    setDistrictfilter([]);
    const nextFilter = {
      lang_id: value,
      state_id: -1,
      district_id: -1,
      constituency_id: -1,
      zone_id: -1,
    };
    setTarget_filter(nextFilter);
    fetchAds(0, nextFilter);
  };

  const StateFilterChange = async (value) => {
    setStatefilter(value);
    setSelectdistrict(-1);
    setSelectedConstituency(-1);
    setDistrictfilter([]);
    setConstituencyfilter([]);
    if (parseInt(value, 10) !== -1) {
      try {
        const res = await api({
          url: "/location/getDistrictsByStateId",
          method: "POST",
          responseType: "json",
          data: { states: [value], langs: [langfilter] },
        });
        const districts = (res.data || []).map((item) => ({
          value: item,
          label: `${item.dist_name}`,
        }));
        setDistrictfilter(districts);
      } catch (error) {
        console.error(error);
        if (error.response?.status === 401) navigate("/");
      }
    }
    const nextFilter = {
      lang_id: target_filter.lang_id,
      state_id: value,
      district_id: -1,
      constituency_id: -1,
      zone_id: -1,
    };
    setTarget_filter(nextFilter);
    fetchAds(0, nextFilter);
  };

  const DistrictFilterChanger = (value) => {
    setSelectdistrict(value);
    setSelectedConstituency(-1);
    setConstituencyfilter([]);
    const nextFilter = {
      lang_id: target_filter.lang_id,
      state_id: target_filter.state_id,
      district_id: value,
      constituency_id: -1,
      zone_id: -1,
    };
    setTarget_filter(nextFilter);
    fetchAds(0, nextFilter);
  };

  const ConstituencyFilterChange = async (value) => {
    setSelectedConstituency(value);
    const nextFilter = {
      lang_id: target_filter.lang_id,
      state_id: target_filter.state_id,
      district_id: target_filter.district_id,
      constituency_id: value,
      zone_id: -1,
    };
    setTarget_filter(nextFilter);
    fetchAds(0, nextFilter);
  };

  const fetchConstituencies = async (districtId) => {
    try {
      const res = await api({
        url: "/location/getConstituentsnew",
        method: "POST",
        responseType: "json",
        data: { districts: [districtId], langs: [langfilter] },
      });
      const mandals = (res.data || []).map((item) => ({
        value: item.const_id,
        label: `${item.const_name}`,
      }));
      setConstituencyfilter(mandals);
    } catch (error) {
      console.error(error);
      if (error.response?.status === 401) navigate("/");
    }
  };

  const getSlotData = (positionKey) => {
    const slotData = adData?.[positionKey]?.[3];
    if (slotData) return slotData;
    return adData?.[positionKey]?.[0] || {};
  };

  const handleOpenInternalAds = (position, from, ads, rotationValue = 0, slotValue = 3) => {
    setInternalAds(ads || []);
    setShowInternalAds(true);
    setAddFrom(from);
    setSelectedPosition(position);
    setRotation(rotationValue);
    setSelectedSlot(slotValue);
  };

  const handleSubmitGamBackfillType = async (payload) => {
    try {
      await api({
        url: "/backfilladunit/updateBackfillWidgetTypes",
        method: "POST",
        responseType: "json",
        data: payload,
      });
      Toast("success", "Updated");
      setEditingGamBackfillType({});
      fetchAds(0, target_filter);
    } catch (error) {
      Toast("error", "Update failed");
      console.error(error);
    }
  };

  const positionKeys = Object.keys(adData || {});
const hasNonEmptyArray = (item) =>{
  return item?.gamAds?.length > 0 || item?.widgetAds?.length > 0 || item?.langAdIds?.length > 0 || item?.stateAdIds?.length > 0 || item?.districtAdIds?.length > 0 || item?.zoneAdIds?.length > 0 || item?.constituencyAdIds?.length > 0
}

console.log(selectedPosition)

  return (
    <>
      <div className="adUnitStickyHead">
        <h5>Backfill AdUnits</h5>
        <div className="d-flex gap-3 justify-content-end mobileNegFil">
          <div className="flex items-center gap-3">
            <aside className="flex items-center gap-3 justify-center mobHide">
                   <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={scheduled}
                onChange={handleScheduled}
                id="schedule"
              />
              <label className="form-check-label" htmlFor="schedule">
                Show Scheduled
              </label>
            </div>
              {localStorage.getItem("role") !== roles.advertiser &&
                localStorage.getItem("role") !== roles.salesperson && (
                  <div>
                    <SlSelect
                      placeholder="Select Language"
                      name="lang"
                      size="small"
                      onSlChange={LanguageFilterChange}
                      value={langfilter}
                    >
                      <SlIcon
                        library="lucide"
                        name="globe"
                        slot="prefix"
                      ></SlIcon>
                      {languageOptions.map((item) => (
                        <SlOption key={item.value} value={item.value}>
                          {item.label}
                        </SlOption>
                      ))}
                    </SlSelect>
                  </div>
                )}
              {langfilter !== -1 && (
                <div>
                  <SlSelect
                    placeholder="Select State"
                    name="state"
                    size="small"
                    onSlChange={(e) => {
                      StateFilterChange(e.target.value);
                    }}
                  >
                    <SlIcon
                      library="lucide"
                      name="globe"
                      slot="prefix"
                    ></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {stateOptions
                      .filter((item) => item.lang_id === +langfilter)
                      .map((item) => (
                        <SlOption key={item.state_id} value={item.state_id}>
                          {item.state_name}
                        </SlOption>
                      ))}
                  </SlSelect>
                </div>
              )}
              {statefilter !== -1 && (
                <div>
                  <SlSelect
                    placeholder="Select District"
                    name="district"
                    size="small"
                    onSlChange={(e) => {
                      DistrictFilterChanger(e.target.value);
                      if (e.target.value && e.target.value !== "-1") {
                        fetchConstituencies(e.target.value);
                      } else {
                        setConstituencyfilter([]);
                        setSelectedConstituency(-1);
                      }
                    }}
                  >
                    <SlIcon
                      library="lucide"
                      name="globe"
                      slot="prefix"
                    ></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {districtfilter.map((item) => (
                      <SlOption
                        key={item.value.dist_id}
                        value={item.value.dist_id}
                      >
                        {item.label}
                      </SlOption>
                    ))}
                  </SlSelect>
                </div>
              )}
              {districtselect !== -1 && (
                <div>
                  <SlSelect
                    placeholder="Select Constituency"
                    name="constituency"
                    size="small"
                    onSlChange={(e) => {
                      ConstituencyFilterChange(e.target.value);
                    }}
                  >
                    <SlIcon
                      library="lucide"
                      name="globe"
                      slot="prefix"
                    ></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {constituencyfilter.map((item) => (
                      <SlOption key={item.value} value={item.value}>
                        {item.label}
                      </SlOption>
                    ))}
                  </SlSelect>
                </div>
              )}
            </aside>
          </div>
        </div>
         <div className="posList">
                <ul>
                {Object.keys(adData).map((item, indexMain) => {
                return (hasNonEmptyArray(adData[item]) ? 
                  <li
                    key={`${item}-${JSON.stringify(adData[item])}`} // More unique key
                    style={{
                      backgroundImage: getPositionClassName(adData[item]),
                      backgroundRepeat: "no-repeat",
                      backgroundSize: 'cover'
                    }}
                    className={getPositionClassName(adData[item]).includes('linear') ? 'active' : getPositionClassName(adData[item])}
                    onClick={() => {scrollToSection(`ad-${indexMain}`); setSelectedPosition(indexMain)}}
                  >
                    {indexMain}
                  </li> : null)
              }).filter(i => i)}
                </ul>
            </div>
        <div className="color-legend backfill-legend">
          {DIMENSION_LEGEND.map(([label, color]) => (
            <span className="cl-item" key={label} title={label}>
              <span className="cl-dot" style={{ backgroundColor: color }} />
              {label}
            </span>
          ))}
        </div>
      </div>
               
      <div className="my-2 p-1">
        <div className="adunit-container twoColumns">
          {loader ? (
            <div className="d-flex justify-center item">
              <div className="text-gray-600">Loading...</div>
            </div>
          ) : positionKeys.length ? (
            positionKeys.map((item, index) => {
              const slotData = adData[item].backfillAds;
              const gamAds = adData[item].gamAds || [];
              const widgetAds = adData[item].widgetAds || [];
              if(gamAds.length == 0 && !widgetAds?.length && slotData?.langAdIds?.length === 0 && slotData?.stateAdIds?.length === 0 && slotData?.districtAdIds?.length === 0 && slotData?.zoneAdIds?.length === 0 && slotData?.constituencyAdIds?.length === 0){
                return 
              }
              const enabled = gamAds?.some(item =>
                isOnly300x250(item.banner_size) &&
                isOnly300x250(item.other_banner_size) &&
                isOnly300x250(item.banner_size_8_87) &&
                (item.recads?.length === 0)
              ) ?? false;
              let disabled =  (!enabled || disableActions);
              if((widgetAds?.length || slotData?.langAdIds?.length || slotData?.stateAdIds?.length || slotData?.districtAdIds?.length || slotData?.zoneAdIds?.length || slotData?.constituencyAdIds?.length) && !disableActions ){
                disabled = false;
              }

              const isEditing = editingGamBackfillType?.position === item;
              return (
                <div className={`unitCard ${+selectedPosition == item ? 'active' :''}`} key={item} id={`ad-${item}`}>
                  <div className="posNum" style={{ "--donut": buildDonutFromCounts(
                    ["langAdIds", "stateAdIds", "districtAdIds", "zoneAdIds", "constituencyAdIds"]
                      .map((k) => (slotData?.[k] || []).length)
                  ) }}>
                    <span>{item}</span>
                    <small className="posOn">{gamAds.length} GAM</small>
                  </div>
                  <div className={`gamNetBfill ${disabled ? "disabled" : ""}`}>
                   <div className="secTitle">GAM Widget Config</div>
                   <BackfillGAMForm
                item={item}
                widgetAds={widgetAds}
                BACKFILL_GAM_INTERNAL_OPTIONS={BACKFILL_GAM_INTERNAL_OPTIONS}
                getBackfillGamPageOptions={getBackfillGamPageOptions}
                getBackfillGamPageLabel={getBackfillGamPageLabel}
                normalizeBackfillGamPage={normalizeBackfillGamPage}
                handleSubmitGamBackfillType={handleSubmitGamBackfillType}
                setEditingGamBackfillType={setEditingGamBackfillType}
                editingGamBackfillType={editingGamBackfillType}
                disabled={disabled} // Set to true if form should be disabled
                isEditing={isEditing}
                lang_id={target_filter.lang_id}
                position={item.position}
              />
                  </div>

                  <div className="panelAds tableType">
                    <div className="secTitle sub">Backfill Targeting</div>
                    <div className="posTypeRow posTypeHead">
                      {["Language", "State", "District", "Zone", "Constituency"].map((label) => (
                        <div key={label} className="posHead">
                          <label>{label}</label>
                        </div>
                      ))}
                    </div>
                    <div className="posTypeRow">
                      {[
                        { key: "langAdIds", from: 1, color: "text-green-700" },
                        { key: "stateAdIds", from: 2, color: "text-purple-700" },
                        { key: "districtAdIds", from: 3, color: "text-orange-600" },
                        { key: "zoneAdIds", from: 5, color: "text-pink-600" },
                        { key: "constituencyAdIds", from: 4, color: "text-blue-600" },
                      ].map((col) => {
                        const count = (slotData?.[col.key] || []).length;
                        return (
                          <div
                            key={col.key}
                            className={`pos ${count > 0 ? "active" : ""}`}
                          >
                            <button
                              type="button"
                              disabled={disabled}
                              onClick={() =>
                                handleOpenInternalAds(
                                  item,
                                  col.from,
                                  slotData?.[col.key] || [],
                                  slotData?.rotation || 0,
                                  3,
                                )
                              }
                              className={col.color}
                            >
                              {count}
                            </button>
                          </div>
                        );
                      })}
                    </div>
                </div>
                </div>
              )
            })
          ) : (
            <div className="d-flex justify-center item">
              <div className="no-data">
                <svg
                  data-v-5eed88b5=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  className="bird-icon flip"
                  strokeWidth="1"
                >
                  <path d="M16 7h.01"></path>
                  <path d="M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20"></path>
                  <path d="m20 7 2 .5-2 .5"></path>
                  <path d="M10 18v3"></path>
                  <path d="M14 17.75V21"></path>
                  <path d="M7 18a6 6 0 0 0 3.84-10.61"></path>
                </svg>
                <h2>No Data Found</h2>
              </div>
            </div>
          )}
        </div>
      </div>
      {showInternalAds && selectedPosition !== undefined && addFrom ? (
        <InternalAds
          show={showInternalAds}
          setShow={setShowInternalAds}
          internalAds={internalAds}
          setInternalAds={setInternalAds}
          position={selectedPosition}
          setPosition={setSelectedPosition}
          from={addFrom}
          target={target_filter}
          fetchAds={fetchAds}
          slot={selectedSlot}
          backfill={true}
          target_filter={target_filter}
          rotation={rotation}
          allBackfillPositions={positionKeys.filter(key => {
            const gamAds = adData[key]?.gamAds || [];
            const widgetAds = adData[key]?.widgetAds || [];
            return gamAds.length > 0 || widgetAds.length > 0;
          })}
        />
      ) : null}
    </>
  );
}

export default BackfillAdUnits;
